// Copyright (c) 2022 by Move Closer

import { Component, Vue } from 'vue-property-decorator'

import { AllowedHAlignment } from '../../contexts/content/allowed'

import { logger } from '../../support'

/**
 * Extendable component that's capable of receiving the `align` @Prop
 * and transforming it into the target CSS class using the specified enum-classname registry.
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
@Component<UseAlignment>({ name: 'UseAlignment' })
export class UseAlignment extends Vue {
  protected align: string = AllowedHAlignment.Center
  protected alignDesktop: string | undefined = undefined

  public readonly alignmentRegistry: {
    base: { [key: string]: string }
    desktop: { [key: string]: string }
  } = {
    base: {
      [AllowedHAlignment.Center]: 'text-center',
      [AllowedHAlignment.Justify]: 'text-justify',
      [AllowedHAlignment.Left]: 'text-left',
      [AllowedHAlignment.Right]: 'text-right'
    },
    desktop: {
      [AllowedHAlignment.Center]: 'text-lg-center',
      [AllowedHAlignment.Justify]: 'text-lg-justify',
      [AllowedHAlignment.Left]: 'text-lg-left',
      [AllowedHAlignment.Right]: 'text-lg-right'
    }
  }

  public get alignmentClassName (): string {
    if (!this.align.length) {
      return ''
    }

    const classNameBase: string = this.alignmentRegistry.base[this.align]
    const classNameDesktop: string = this.alignmentRegistry.desktop[this.alignDesktop ?? this.align]

    if (typeof classNameBase === 'undefined' && typeof classNameDesktop === 'undefined') {
      logger(`[Alignmentable]: There's no CSS class binding for the neither [base.${this.align}] nor [desktop.${this.alignDesktop}] alignment! Returning empty string!`, 'warn')
      return ''
    }

    return `${classNameBase} ${classNameDesktop}`
  }
}
